import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Jouw toestemmingen',
  empty: 'Geen toestemmingsverzoeken van toepassing op jou.',
  collectiveNote:
    'Er geldt een collectieve registratie op de afdeling; je persoonlijke antwoord heeft geen effect zolang die van kracht is.',
  table: {
    department: 'Afdeling',
    status: 'Status',
    basis: 'Geldende basis',
  },
  status: {
    pending: 'Wacht op jouw antwoord',
    granted: 'Verleend',
    denied: 'Geweigerd',
  },
  basis: {
    personal: 'Persoonlijk',
    collective: 'Collectief',
  },
  actions: {
    grant: 'Toestaan',
    deny: 'Weigeren',
    withdraw: 'Intrekken',
  },
};
